export default function IconPhone({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path d="M6.62 10.79C8.06 13.96 10.94 16.84 14.11 18.28L16.59 15.8C16.85 15.54 17.22 15.46 17.55 15.57C18.84 16 20.24 16.23 21.66 16.23C22.4 16.23 23 16.83 23 17.57V21C23 21.55 22.55 22 22 22C10.42 22 2 13.58 2 2C2 1.45 2.45 1 3 1H6.43C7.17 1 7.77 1.6 7.77 2.34C7.77 3.76 8 5.16 8.43 6.45C8.54 6.78 8.46 7.15 8.2 7.41L5.72 9.89C5.72 9.89 5.72 9.89 5.72 9.89C5.43 10.18 5.35 10.63 5.49 10.97C5.49 10.97 5.49 10.97 5.49 10.97L6.62 10.79Z" />
        </svg>
    );
}
